var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgGeofences = function SvgGeofences(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.49 0a2.81 2.81 0 0 1 .651 5.543v9.214a2.811 2.811 0 0 1-.651 5.543 2.81 2.81 0 0 1-2.733-2.159H5.543A2.811 2.811 0 0 1 0 17.49a2.81 2.81 0 0 1 2.159-2.733V5.543A2.811 2.811 0 0 1 2.81 0a2.81 2.81 0 0 1 2.733 2.159h9.214A2.811 2.811 0 0 1 17.491 0zm0 15.982A1.508 1.508 0 1 0 17.491 19a1.51 1.51 0 0 0-.001-3.018zm-14.68 0a1.51 1.51 0 1 0 0 3.018 1.51 1.51 0 0 0-.001-3.018zM14.757 3.459H5.543a2.813 2.813 0 0 1-2.084 2.084v9.214a2.813 2.813 0 0 1 2.084 2.084h9.214a2.813 2.813 0 0 1 2.084-2.084V5.543a2.813 2.813 0 0 1-2.084-2.084zM17.491 1.3a1.51 1.51 0 1 0 .002 3.02 1.51 1.51 0 0 0-.003-3.02zm-14.682 0a1.51 1.51 0 1 0 .001 3.02A1.51 1.51 0 0 0 2.81 1.3z"
  })));
};

export default SvgGeofences;